import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

export interface CardProps {
  title: string;
  description: string;
  to: string;
  icon: ReactNode;
}

export function Card({ title, description, to, icon }: CardProps) {
  return (
    <Link
      to={to}
      className="group flex flex-col rounded-lg border border-slate-200 bg-white p-5 shadow-sm transition hover:border-brand-500 hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 dark:border-slate-800 dark:bg-slate-900 dark:hover:border-brand-500"
    >
      <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-md bg-brand-50 text-brand-600 dark:bg-brand-900/30 dark:text-brand-100">
        {icon}
      </div>
      <h3 className="mb-1 text-lg font-semibold text-slate-900 dark:text-slate-100">{title}</h3>
      <p className="text-sm text-slate-600 dark:text-slate-400">{description}</p>
    </Link>
  );
}
